<template>
  <div id="spnod-app">
    <div class="spnod-admin">
      <div class="small-header" :class="displayMenu ? 'between' : ''">
        <Hamburger v-if="displayMenu"/>
        <img :src="logoPath" width="100px" />
        <div v-if="displayMenu" id="placeholder"></div>
      </div>
      <div class="spnod-page__admin">
        <router-view></router-view>
      </div>
      <div v-show="showSpinner" class="spnod-overlay">
        <div class="loader page-loader">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Promise } from 'bluebird'
import { IMAGE_PATH } from '../config'
import { mapActions, mapGetters } from 'vuex'
import Notification from './components/Notifications/Notification'
import Hamburger from './components/Icons/Hamburger'
import Vue from 'vue'

export default {
  name: 'spnod-app',
  components: { Hamburger, Notification },
  computed: {
    imagePath() {
      return IMAGE_PATH
    },
    ...mapGetters([
      'loggedIn',
      'subscriptions',
      'nutritionSurveySchema',
      'getMessages',
      'getMyInfo',
      'surveyStep',
      'hasUnread',
      'newMessage',
      'newSignup',
      'getActiveSubscription',
      'showSpinner'
    ]),
    logoPath() {
      return IMAGE_PATH + '/spnod_logo.png'
    },
    mailIconPath() {
      return IMAGE_PATH + '/envelope.svg'
    },
    isMobile() { return window.innerWidth <= 768 },
    displayMenu() { return this.loggedIn && this.isMobile }
  },
  data() {
    return {
      messageCounts: {}
    }
  },
  methods: {
    ...mapActions([
      'getUserFromLocalStorage',
      'loadPlans',
      'loadMessages',
      'getMessageThreadCount',
      'getMe',
      'updateUnread',
      'newMessageToast',
      'listenForMessages',
      'listenForSignups'
    ]),
    triggerNotification(newMessage, threadId) {
      console.log(newMessage)
      this.newMessageToast(newMessage)
      this.updateUnread(true)
    },
    triggerNewSignup(newSignup) {
      console.log(newSignup)
      this.updateUnread(true)
    },
    async getAllMessages() {
      if (this.getMessages.length < 1) await this.loadMessages()
      this.getMessages.forEach((message) => {
        // TODO: Maybe check if message has messageFlagged === true
        if (message.totalMessagesUnreadByMe > 0) {
          console.log('marking has unreads:', message.totalMessagesUnreadByMe)
          this.updateUnread(true)
        }
        this.listenForMessages(message.threadId)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    closeNotification() {
      this.showIENotification = false
    }
  },
  beforeCreate() {
    this.$store.commit('SET_STRIPE_PUBLISHABLE_KEY')
  },
  beforeMount() {
    try {
      let proxyTest = new Proxy({}, {})
      if (proxyTest instanceof Object) {
        console.log('Proxy supported!')
      } else {
        console.log('Proxy not supported!')
        this.showIENotification = true
      }
    } catch (err) {
      console.log('Proxy not supported!')
      this.showIENotification = true
    }
  },
  async mounted() {
    if (this.loggedIn === true && this.getMyInfo === null) {
      const res = await this.getUserFromLocalStorage('user')
      if (res === null) {
        await this.getMe()
      }
    } else if (this.loggedIn === true && this.getMyInfo !== null) {
      await this.getAllMessages()
    }
  },
  watch: {
    loggedIn: async function (newVal, oldVal) {
      console.log('loggedIn change on app.vue')
      if (newVal === false) {
        this.updateUnread(false)
        this.$router.push('/login')
      } else {
        let promises = [this.getMe]
        if (!this.getActiveSubscription) promises.push(this.loadPlans)
        console.log('fetching subscription')
        Vue.$socketApi.reconnect()
        try {
          await Promise.all(promises)
        } catch (err) {
          console.log(err)
        }
      }
    },
    getMyInfo: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.getMyInfo && this.getMyInfo.hasRoles) {
          this.listenForSignups(this.getMyInfo._id)
        }
      }
    },
    hasUnread: function (newVal, oldVal) {
      console.log(newVal)
    },
    getMessages: function (newVal, oldVal) {
      let messageThreadsLength = 0
      if (newVal.length) messageThreadsLength = newVal.length
      for (let i = 0; i < messageThreadsLength; i++) {
        this.messageCounts[newVal[i].threadId] = newVal[i].totalMessages
      }
    },
    newMessage: async function (newVal, oldVal) {
      const threadId = newVal.message.threadId
      const fromMe = newVal.message.sender._id === this.getMyInfo._id
      if (!this.$route.query.threadId || this.$route.query.threadId !== threadId) {
        const newMessage = newVal.message
        let response = await this.getMessageThreadCount(newVal.message._id)
        let messagesCount = response.total
        if (
          !fromMe &&
          this.messageCounts[threadId] &&
          messagesCount > this.messageCounts[threadId]
        ) {
          this.triggerNotification(newMessage, threadId)
        }
        this.messageCounts[threadId] = messagesCount
      }
    },
    newSignup: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.triggerNewSignup(newVal)
        if (this.$router.currentRoute.name !== 'messages') {
          this.loadMessages()
          this.loadPlans()
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../node_modules/vue-date-pick/src/vueDatePick';
@import '../assets/sass/reset';
@import '../assets/sass/variables';
@import '../assets/sass/mixins';
@import '../assets/sass/functions';
@import '../assets/sass/flatIcon';
@import '../assets/sass/grid';
@import '../assets/sass/form';
@import '../assets/sass/loader';
@import '../assets/sass/modal';
@import '../assets/sass/text';
@import '../assets/sass/elements';
@import '../assets/sass/multiSelect';
@import '../assets/sass/messages';
@import '../assets/sass/notifications';
@import '../assets/sass/table';
@import '../assets/sass/animations';
@import '../assets/sass/positions';

*,
*:before,
*:after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}
html,
body,
.spnod-page {
  font-family: 'Helvetica Neue Light', 'HelveticaNeue-Light', 'Helvetica Neue', Calibri,
    Helvetica, Arial;
  font-size: 20px;
  min-height: 100vh;
}
.spnod-page {
  position: relative;
}
.small-header {
  width: 100%;
  height: 50px;
  padding: 5px 10px !important;
  margin: auto;
  background-color: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
}
.spnod-admin {
  width: 100%;
  display: flex;
  position: absolute;
  flex-direction: column;
}
.spnod-page__admin {
  min-height: calc(100vh - 50px);
  display: flex !important;
}

#placeholder {
  width: 20px;
  height: 20px;
}

#menu {
  width: 20px;
  height: 20px;
  background-color: white;
}

.between {
  justify-content: space-between !important;
}
</style>



// WEBPACK FOOTER //
// src/app/App.vue?b369706c